import { render } from "./ConstructorHeader.vue?vue&type=template&id=264ad4cf&scoped=true&ts=true"
import script from "./ConstructorHeader.vue?vue&type=script&lang=ts"
export * from "./ConstructorHeader.vue?vue&type=script&lang=ts"

import "./ConstructorHeader.vue?vue&type=style&index=0&id=264ad4cf&lang=scss&scoped=true"

import exportComponent from "/srv/users/dyo-frontend-staging/apps/dyo-frontend-staging/public_html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-264ad4cf"]])

export default __exports__